import { TextInput, Label, TextInputProps } from "flowbite-react";
import { forwardRef } from "react";

interface CustomTextInputProps extends TextInputProps {
  id?: string;
  label: string;
  error?: string;
}

const CustomTextInput = forwardRef<HTMLInputElement, CustomTextInputProps>(
  ({ id, label, error, ...props }, ref) => {
    return (
      <div className="mb-4">
        <Label htmlFor={id}>{label}</Label>
        <TextInput id={id} ref={ref} {...props} />
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    );
  },
);

CustomTextInput.displayName = "CustomTextInput";

export default CustomTextInput;
